import React from 'react'

const SessionMainPanel = ({ children, layout }) => {
  const blockType = layout ? `__${layout}` : ''
  return <section className={`pb-session${blockType}`}>{children}</section>
}

export default SessionMainPanel
